// @ts-nocheck
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

// Material UI
import {
  List,
  ListItem,
  Switch,
  Typography,
  Paper,
  Box,
  Divider,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SecurityIcon from '@material-ui/icons/Security';

// Project
import { selectState, actionProps } from 'utils/reduxActions';
import { ReactReduxContext } from 'config/configureStore';
import connectSaga from 'utils/saga';
import styles from './style';
import saga from './saga';
import { featureFlagsActions } from './reducer';

const useStyles = makeStyles(styles);

function FeatureFlags(props) {
  const { permissions, actions, loading, loaders } = props;
  const classes = useStyles();

  useEffect(() => {
    actions.getStateFromApi();
  }, [actions]);

  // Handle permissions as an object or nested object as per user's log
  const permissionsData = permissions?.permissions || permissions || {};
  const permissionsList = Object.values(permissionsData);

  const handleToggle = (p) => (event) => {
    actions.editPermission(p.permission_id, event.target.checked);
  };

  return (
    <Box p={3} width="100%">
      <Paper elevation={3} className={classes.root} style={{ width: '100%' }}>
        <Box p={2} display="flex" alignItems="center" justifyContent="space-between" bgcolor="primary.main" style={{ borderRadius: '4px 4px 0 0', color: '#fff' }}>
          <Box display="flex" alignItems="center">
            <SecurityIcon style={{ marginRight: 16}} />
            <Typography variant="h5" style={{ color: '#fff' }}>
              Permissions Management
            </Typography>
          </Box>
          {loading && <CircularProgress size={24} style={{ color: '#fff' }} />}
        </Box>
        <Divider />
        <Box>
          {loading && (!permissionsList || permissionsList.length === 0) ? (
            <Box display="flex" justifyContent="center" p={5}>
              <CircularProgress />
            </Box>
          ) : permissionsList.length > 0 ? (
            <List disablePadding>
              {permissionsList.map((p, index) => {
                const isToggling = loaders[`edit-flag-${p.permission_id}`];
                return (
                  <React.Fragment key={p.id}>
                    <ListItem
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '20px 32px',
                      }}
                    >
                      <Box textAlign="left">
                        <Typography variant="subtitle1" color="primary" style={{ fontWeight: 600 }}>
                          {p.permission?.name || 'No Name'}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {p.permission?.description || 'No Description'}
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center">
                        {isToggling && <CircularProgress size={20} style={{ marginRight: 16 }} />}
                        <Switch
                          checked={!!p.is_active}
                          onChange={handleToggle(p)}
                          color="primary"
                          disabled={isToggling}
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                      </Box>
                    </ListItem>
                    {index < permissionsList.length - 1 && <Divider />}
                  </React.Fragment>
                );
              })}
            </List>
          ) : (
            <Box p={3} textAlign="center">
              <Typography color="textSecondary">
                No permissions found
              </Typography>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

const withSaga = connectSaga({ key: 'sagaFeatureFlags', saga });

const withConnect = connect(
  (state) => ({
    ...selectState('featureFlags.permissions')(state),
    loading: state.app.loaders['get-feature-flags'],
    loaders: state.app.loaders || {},
  }),
  actionProps(featureFlagsActions),
  null,
  {
    context: ReactReduxContext,
  },
);

export default compose(withConnect)(withSaga(FeatureFlags));
